import React from 'react';
import { useTheme } from 'styled-components';
import { StyledBody, StyledBody2 } from '../common/typography';
import { toHtmlSanitize } from '../../utils/remark-html';
import { Table, StyledColGroup, StyledCurvedTh, StyledCurvedTd, TD, TH } from './styles';
import { Text } from '../common/TypographyPublicSite';

export default ({ description, firstHeading, secondHeading, firstRow, secondRow, thirdRow }) => {
  const theme = useTheme();
  return (
    <Table aria-label={description}>
      <StyledColGroup>
        <col />
        <col />
        <col />
      </StyledColGroup>
      <thead>
        <tr>
          <TD topLeftRounded />
          <StyledCurvedTh scope="col" roundedTopEdges>
            <Text data-color="contentReverse">{firstHeading}</Text>
          </StyledCurvedTh>
          <TH scope="col" topRightRounded>
            <Text data-color={theme.palette.content}>{secondHeading}</Text>
          </TH>
        </tr>
      </thead>
      <tbody>
        {firstRow && (
          <tr>
            <th scope="row">
              <StyledBody2 dangerouslySetInnerHTML={{ __html: toHtmlSanitize(firstRow[0]) }} />
            </th>
            <td>
              <Text dangerouslySetInnerHTML={{ __html: toHtmlSanitize(firstRow[1]) }} data-color="contentReverse" />
            </td>
            <td>
              <StyledBody dangerouslySetInnerHTML={{ __html: toHtmlSanitize(firstRow[2]) }} />
            </td>
          </tr>
        )}
        {secondRow && (
          <tr>
            <th scope="row">
              <StyledBody2 dangerouslySetInnerHTML={{ __html: toHtmlSanitize(secondRow[0]) }} />
            </th>
            <td>
              <Text data-color="contentReverse" dangerouslySetInnerHTML={{ __html: toHtmlSanitize(secondRow[1]) }} />
            </td>
            <td>
              <StyledBody dangerouslySetInnerHTML={{ __html: toHtmlSanitize(secondRow[2]) }} />
            </td>
          </tr>
        )}
        {thirdRow && (
          <tr>
            <TH scope="row" bottomLeftRounded>
              <StyledBody2 dangerouslySetInnerHTML={{ __html: toHtmlSanitize(thirdRow[0]) }} />
            </TH>
            <StyledCurvedTd roundedBottomEdges>
              <Text dangerouslySetInnerHTML={{ __html: toHtmlSanitize(thirdRow[1]) }} data-color="contentReverse" />
            </StyledCurvedTd>
            <TD bottomRightRounded>
              <StyledBody dangerouslySetInnerHTML={{ __html: toHtmlSanitize(thirdRow[2]) }} />
            </TD>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
